import MJSONDesigner from '@admin/components/mjson_designer'
import ImageTools from '@admin/components/image_tools'
import Panel from '@admin/components/panel'
import PropTypes from 'prop-types'
import React from 'react'

class Design extends React.Component {

  static propTypes = {
    advisor: PropTypes.object,
    theme: PropTypes.object
  }

  render() {
    return <MJSONDesigner { ...this._getMJSONDesigner() } />
  }

  _getMJSONDesigner() {
    const { advisor, theme } = this.props
    return {
      endpoint: `/maha_themes/${theme.id}`,
      library: `/advisors/${advisor.id}`,
      preview: `/mjson/dynamic/maha_themes/${theme.code}`,
      root_route: `/truevail/admin/advisors/${advisor.id}/theme-${theme.id}`,
      type: 'page',
      versionable: true
    }
  }

}

const mapPropsToPanel = (props, context) => ({
  title: 't(Design)',
  component: <Design advisor={ props.advisor } theme={ props.theme } />,
  tasks: {
    items: [
      { 
        label: 't(Generate Image)',
        svg: 'wand_sparkles',
        modal: <ImageTools /> 
      }
    ]
  }
})

export default Panel(null, mapPropsToPanel)
